<style lang="scss">
.AEE-nav {
    a {
        display: inline-block;
    }
    .nav_flex {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .vertical {
        display: flex;
        flex-direction: column;
    }
    .horizontal {
        display: flex;
        flex-direction: row;
    }
    .el-menu {
        border-right: 0px !important;
    }
}
</style>
<template>
    <div class="AEE-nav">
        <el-menu
            :default-active="activeIndex"
            :class="mode"
        >
            <template v-for="item in router_link_list">
                <router-link :to="item.to">
                    <div class="nav_flex">
                        <span
                            class="nav_icon"
                            v-if="item.icon"
                        >
                            <img
                                :src="item.icon"
                                alt
                            />
                        </span>
                        <el-menu-item :index="item.index"><span>{{item.menu_name}}</span> </el-menu-item>
                    </div>
                </router-link>
            </template>
        </el-menu>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    props: {
        mode: {
            default: "horizontal"
        },
        router_link_list: {}
    },
    data() {
        return {};
    },
    computed: {
        activeIndex: {
            get() {
                // this.$emit('getData')
                return this.$store.state.common.headerState;
            }
        }
    },
    watch: {
        activeIndex:function(value){
          console.log(value)
          this.$emit('getData')
        }
    },
    created: function() {}
};
</script>